import React from 'react';

/**
 * BlogAuthorBio - Author information section
 * 
 * @param {Object} props
 * @param {string} props.name - Author name
 * @param {string} [props.title] - Author's role/title
 * @param {string} [props.bio] - Short biography
 * @param {string} [props.image] - Author photo URL
 * @param {string} [props.profileUrl] - Link to author's profile page
 */
export const BlogAuthorBio = ({ 
  name, 
  title, 
  bio, 
  image,
  profileUrl 
}) => {
  const AuthorImage = () => (
    image ? (
      <img 
        src={image} 
        alt={name}
        className="w-16 h-16 rounded-full object-cover"
      />
    ) : (
      <div className="w-16 h-16 rounded-full bg-[#1A1A1A] flex items-center justify-center">
        <span className="text-2xl text-[#00E87A] font-semibold">
          {name.charAt(0).toUpperCase()}
        </span>
      </div>
    )
  );

  return (
    <section 
      className="mt-12 pt-8 border-t border-gray-700"
      data-testid="blog-author-bio"
    >
      <div className="flex items-start space-x-4">
        {profileUrl ? (
          <a href={profileUrl} className="flex-shrink-0">
            <AuthorImage />
          </a>
        ) : (
          <div className="flex-shrink-0">
            <AuthorImage />
          </div>
        )}
        <div>
          {profileUrl ? (
            <a 
              href={profileUrl}
              className="text-lg font-semibold text-white hover:text-[#00E87A] transition-colors"
            >
              {name}
            </a>
          ) : (
            <h4 className="text-lg font-semibold text-white">{name}</h4>
          )}
          {title && (
            <p className="text-gray-400 text-sm mb-2">{title}</p>
          )}
          {bio && (
            <p className="text-gray-200 text-sm">{bio}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default BlogAuthorBio;
